import {UploadLogoClienteService} from '../services'

export default (formData) => {
    return new Promise((resolve, reject) => {
        UploadLogoClienteService.upload(formData)
            .then(response => {
                resolve({ success: true, data: response.data })
            })
            .catch(err => {
                reject(err.response || err)
            })
    })
}

